import React from 'react';
import { StepProps } from '../../types';
import { motion } from 'framer-motion';
import { ArrowRight, Target, TrendingUp, AlertCircle } from 'lucide-react';
export function BrandContext({
  nextStep
}: StepProps) {
  return <div className="flex-grow flex flex-col py-12 px-6 overflow-y-auto" data-id="element-190">
      <div className="max-w-4xl w-full mx-auto" data-id="element-191">
        <div className="text-center mb-12" data-id="element-192">
          <span className="text-brand font-semibold tracking-wider uppercase text-sm mb-2 block" data-id="element-193">
            Brand Context
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-dark" data-id="element-194">
            Where does Kerendia fit?
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-3xl p-8 md:p-12 border-2 border-brand/20 shadow-lg mb-10 text-center" data-id="element-195">
          <Target size={48} className="mx-auto mb-6 text-brand" data-id="element-196" />
          <h3 className="text-2xl font-bold text-dark mb-4" data-id="element-197">
            Kerendia is often positioned as a later-line therapy despite strong
            evidence for earlier use.
          </h3>
          <p className="text-lg text-gray-600 mb-10" data-id="element-198">
            Observed trends suggest: Only ~30% of eligible patients receive
            Kerendia at the optimal time.
          </p>

          {/* Simple Funnel/Timeline Visual */}
          <div className="relative max-w-2xl mx-auto mb-8" data-id="element-199">
            <div className="flex justify-between items-center mb-4 relative z-10" data-id="element-200">
              <div className="w-1/3 text-center" data-id="element-201">
                <div className="w-16 h-16 rounded-full bg-gray-100 border-2 border-gray-300 flex items-center justify-center mx-auto mb-2 text-gray-500 font-bold" data-id="element-202">
                  Early
                </div>
                <span className="text-sm text-gray-500" data-id="element-203">SGLT2i / ACEi</span>
              </div>
              <div className="w-1/3 text-center" data-id="element-204">
                <div className="w-16 h-16 rounded-full bg-brand/10 border-2 border-brand border-dashed flex items-center justify-center mx-auto mb-2 text-brand font-bold" data-id="element-205">
                  Mid
                </div>
                <span className="text-sm text-brand font-bold" data-id="element-206">
                  The Opportunity
                </span>
              </div>
              <div className="w-1/3 text-center" data-id="element-207">
                <div className="w-16 h-16 rounded-full bg-brand text-white flex items-center justify-center mx-auto mb-2 font-bold shadow-md" data-id="element-208">
                  Late
                </div>
                <span className="text-sm text-gray-800 font-medium" data-id="element-209">
                  Current Reality
                </span>
              </div>
            </div>
            {/* Connecting line */}
            <div className="absolute top-8 left-[16.6%] right-[16.6%] h-1 bg-gray-200 -z-0" data-id="element-210"></div>

            {/* Arrow showing movement */}
            <motion.div className="absolute top-12 left-1/2 w-1/3 h-8 border-b-2 border-l-2 border-brand rounded-bl-xl" initial={{
            opacity: 0,
            pathLength: 0
          }} animate={{
            opacity: 1,
            pathLength: 1
          }} transition={{
            delay: 1,
            duration: 1
          }} data-id="element-211">
              <div className="absolute -left-2 -bottom-2 w-4 h-4 border-t-2 border-r-2 border-brand transform -rotate-45 bg-white" data-id="element-212"></div>
            </motion.div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-gray-50 rounded-3xl p-8 border border-gray-200 mb-10" data-id="element-213">
          <div className="flex items-start" data-id="element-214">
            <AlertCircle className="text-gray-400 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-215" />
            <div data-id="element-216">
              <h4 className="text-lg font-bold text-dark mb-2" data-id="element-217">
                The landscape is evolving
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-218">
                ERA, ASi, and other new MoAs are increasing decision complexity.
                As the market becomes more crowded, clear positioning and
                sequencing guidance becomes even more critical for every
                specialty.
              </p>
            </div>
          </div>
        </motion.div>

        <div className="flex justify-center pb-8" data-id="element-219">
          <motion.button initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} onClick={nextStep} className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-dark rounded-full hover:bg-black transition-colors" data-id="element-220">
            See Activation Strategy
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-221" />
          </motion.button>
        </div>
      </div>
    </div>;
}